import { render, staticRenderFns } from "./SendBrochureRequestEmail.vue?vue&type=template&id=2dcaf704&"
import script from "./SendBrochureRequestEmail.vue?vue&type=script&lang=js&"
export * from "./SendBrochureRequestEmail.vue?vue&type=script&lang=js&"
import style0 from "./SendBrochureRequestEmail.vue?vue&type=style&index=0&id=2dcaf704&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports